import type { TagCategoriesConfig } from '@racemap/sdk/schema/events';
import type { Immutable } from 'immer';

/**
 * Returns sorted tag category configuration entries.
 * Entries are sorted by their index value first, then alphabetically by key.
 * @param tagCategoriesConfig - The tag categories configuration to sort
 * @returns Array of [key, config] tuples sorted by index and key
 */
export function getSortedTagCategoriesConfigEntries(
  tagCategoriesConfig: Immutable<TagCategoriesConfig>,
): Array<[string, Immutable<TagCategoriesConfig[string]>]> {
  return Object.entries(tagCategoriesConfig).sort(([keyA, configA], [keyB, configB]) => {
    if (configA.index !== configB.index) return configA.index - configB.index;
    return keyA.localeCompare(keyB);
  });
}
